/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete this key?" |
*
* @param {Options_Api_Keys_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_delete_confirm = /** @type {((inputs?: Options_Api_Keys_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voulez-vous vraiment supprimer cette clé ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sind Sie sicher, dass Sie diesen Schlüssel löschen möchten?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sei sicuro di voler eliminare questa chiave?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены, что хотите удалить этот ключ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Está seguro de que desea eliminar esta clave?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您确定要删除此密钥吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このキーを削除してもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई इस कुंजी को हटाना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza de que deseja excluir esta chave?")
	return /** @type {LocalizedString} */ ("Are you sure you want to delete this key?")
});